import { Component, Prop, Vue } from 'vue-property-decorator';
import { logout } from '../../auth';
import LoginInformation from '../../types/login_information';
import IconText from '../shared/iconText.vue';

@Component({ components: { IconText } })
export default class MainSideBar extends Vue {
  @Prop() public loginInformation!: LoginInformation;

  get currentPage() {
    return this.$route.path;
  }

  public logoutClicked() {
    logout();
  }

  get iconSrcUrl(): string {
    return `https://ui-avatars.com/api/?name=${this.loginInformation.displayName}`;
  }
}
